import { render, staticRenderFns } from "./returnPage.vue?vue&type=template&id=41b9cd3c&scoped=true&"
import script from "./returnPage.vue?vue&type=script&lang=js&"
export * from "./returnPage.vue?vue&type=script&lang=js&"
import style0 from "./returnPage.vue?vue&type=style&index=0&id=41b9cd3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b9cd3c",
  null
  
)

export default component.exports